import { handleFieldChange } from "../../../../Utils";
import { Component } from 'react';
import { Button } from 'react-bootstrap';

import React from 'react';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';

class Form extends Component {
    constructor(props = { domain: '', type: '', note: '' }) {
        super(props);

        this.submit = this.submit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    submit(event) {
        event.preventDefault();

        const data = {};

        for (const [ key, value ] of new FormData(event.target).entries()) {
            if (!value && value !== 0) continue;

            data[key] = value;
        }

        if (!data.id) delete data.id;

        this.props.submit(data);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.close}>
                <form onSubmit={this.submit} style={{height: "auto", maxWidth: "600px", overflowY: 'initial'}}>
                    <input name={'id'} value={this.props.form.id} hidden={true}/>

                    <FieldGroup
                        name="subdomain"
                        label="Subdomain:"
                        defaultValue={this.props.form.subdomain}
                    />

                    <FieldGroup
                        name="domain"
                        label="Domain:"
                        defaultValue={this.props.form.domain}
                        required
                    />

                    <FieldGroup
                        name="hour"
                        label="Hour:"
                        defaultValue={this.props.form.hour}
                        type={'number'}
                        min={0}
                        max={23}
                    />

                    <FieldGroup
                        name="type"
                        defaultValue={this.props.form.type}
                        required
                        label="Type:"
                        list={"types"}
                    />

                    <datalist id="types">
                        {this.props.types.map((row) => <option>{row.type}</option>)}
                    </datalist>

                    <FieldGroup
                        name="note"
                        defaultValue={this.props.form.note}
                        label="Note:"
                    />

                    <Button className="pull-right" bsStyle="success" type="submit">Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/DomainsV2/components/Form/index.js